/**
 * Storefront Hunter saved-product identity on the client.
 *
 * The backend canonical identity is (workspace, walmart_item_id) with the id
 * digit-normalized and zero-trimmed. Client state must use the SAME normalized
 * form, otherwise a padded or whitespace-wrapped id (" 0018228703660 ") would
 * look unsaved while the backend already has it saved — and the same product
 * under another seller would not read as saved.
 *
 * Keying is by normalized Walmart Item ID only: never by array index, and never
 * by seller + item.
 */
export function normalizeSavedItemId(value) {
  const digits = String(value ?? "").replace(/[^0-9]/g, "");
  if (!digits) return "";
  const canonical = digits.replace(/^0+/, "");
  // Same bounds as the backend (4-20 canonical digits).
  if (canonical.length < 4 || canonical.length > 20) return "";
  return canonical;
}

/** Immutable set helpers so React state updates stay pure. */
export function setSavedFlag(prev, itemId, on) {
  const key = normalizeSavedItemId(itemId);
  if (!key) return prev;
  const next = new Set(prev);
  if (on) next.add(key);
  else next.delete(key);
  return next;
}

export function isSaved(prev, itemId) {
  const key = normalizeSavedItemId(itemId);
  return Boolean(key) && prev.has(key);
}

export function withSaving(prev, itemId, on) {
  const key = normalizeSavedItemId(itemId);
  if (!key) return prev;
  const next = new Set(prev);
  if (on) next.add(key);
  else next.delete(key);
  return next;
}
